// This function is used to check if a switch statement is exhaustive
/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const assertUnreachable = (value: never): never => {
  throw new Error("Didn't expect to get here");
};
